class IngredientsList extends HTMLElement {
  constructor() {
    super()

    this.buttons = Array.from(this.querySelectorAll('button[data-property]'))
    this.moveRightBtn = this.querySelector('[data-move-right]')
    this.nav = this.querySelector('[data-nav]')
    this.ingredients = Array.from(this.querySelector('[data-ingredients]').children)

    this.buttons.forEach((btn) => {
      btn.addEventListener('click', this.handleClick.bind(this))
    })

    if (this.moveRightBtn && this.nav) {
      this.moveRightBtn.addEventListener('click', () => {
        if (!this.isMobile()) return
        this.nav.scrollBy({
          left: 100,
          behavior: 'smooth'
        })
      })

      this.nav.addEventListener('scroll', () => {
        if (!this.isMobile()) return
        this.updateMoveRightState()
      })

      window.addEventListener('resize', () => {
        this.updateMoveRightState()
      })

      this.updateMoveRightState()
    }

    // change initially selected element on load
    document.addEventListener('DOMContentLoaded', (event) => {
      const rand = this.buttons[Math.floor(Math.random()*this.buttons.length)]
      if (rand && !rand.classList.contains('active')) {
        rand.click()
      }
    })
  }

  isMobile() {
    return window.matchMedia && window.matchMedia('(max-width: 1100px)').matches
  }

  updateMoveRightState() {
    if (!this.moveRightBtn || !this.nav) return

    if (!this.isMobile()) {
      this.moveRightBtn.disabled = false
      return
    }

    const { scrollLeft, clientWidth, scrollWidth } = this.nav
    const atEnd = scrollLeft + clientWidth >= scrollWidth - 1
    this.moveRightBtn.disabled = atEnd
  }

  handleClick(event) {
    const currentButton = event.currentTarget

    if (currentButton.classList.contains('active')) return

    const termId = currentButton.dataset.property

    this.buttons.forEach((btn) => {
      btn.classList.toggle('active', btn == currentButton)
    })

    this.ingredients.forEach((ingredient) => {
      ingredient.classList.toggle(
        'ingredients__item--active',
        ingredient.dataset.property === termId
      )
    })

    if (this.nav && this.isMobile()) {
      const targetScrollLeft = currentButton.offsetLeft - 16
      this.nav.scrollTo({
        left: targetScrollLeft > 0 ? targetScrollLeft : 0,
        behavior: 'smooth'
      })
    }
  }
}

customElements.define('ingredients-list', IngredientsList)